import './index.scss'
import { TableProps } from './types'
import Simple from './Variations/Simple'
import WithCheckBox from './Variations/WithCheckBox'
import WithDownloadAndDeleteOption from './Variations/WithDownloadAndDeleteOption'
import WithDownloadOption from './Variations/WithDownloadOption'

export default function Table<T, K>({ header, items, selectMultipleRows, onSortCallback, sort, onSingleDownload, onDelete, canDelete }: TableProps<T, K>) {
  const configMap = header.map(config => config.key)
  
  if (selectMultipleRows) {
    return <WithCheckBox configMap={configMap} selectMultipleRows={selectMultipleRows} header={header} items={items} onSortCallback={onSortCallback} sort={sort}/>
  }

  if(onSingleDownload && onDelete) {
    return <WithDownloadAndDeleteOption configMap={configMap} header={header} items={items} onSortCallback={onSortCallback} sort={sort} onSingleDownload={onSingleDownload} onDelete={onDelete} canDelete={canDelete}/>
  }

  if(onSingleDownload) {
    return <WithDownloadOption configMap={configMap} header={header} items={items} onSortCallback={onSortCallback} sort={sort} onSingleDownload={onSingleDownload}/>
  }

  return <Simple  configMap={configMap} header={header} items={items} onSortCallback={onSortCallback} sort={sort}/>
}
